import { useMemo, useRef } from 'react';
import { ToastContainer, ToastOptions } from 'react-toastify';
import Bugsnag from '@bugsnag/js';
import ReactTooltip from 'react-tooltip';
import { rebuildReactTooltip } from '@bpm-web-app/utils';
import styles from './app-toast.module.css';
import { toastTransition } from './toast-transition';
import { useFrontToastTimer } from './use-front-toast-timer';

export const TOAST_DISMISS_TOOLTIP_ID = 'toast-dismiss-tip';

export function AppToast(props: ToastOptions) {
    const containerRef = useRef<HTMLDivElement>(null);
    useFrontToastTimer(containerRef);

    const CustomToastAnimation = useMemo(
        () => toastTransition(),
        []
    );
    const toastConfiguration = useMemo<ToastOptions>(
        () => ({
            autoClose: false,
            position: 'bottom-center',
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            bodyClassName: styles['app-toast__body'],
            className: styles['app-toast'],
            toastClassName: styles['app-toast__container'],
            closeButton: false,
            theme: null,
            transition: CustomToastAnimation,
            onOpen() {
                Bugsnag.leaveBreadcrumb('Toast shown');
                rebuildReactTooltip();
                window.setTimeout(() => rebuildReactTooltip(), 250);
            },
            onClose() {
                Bugsnag.leaveBreadcrumb('Toast hidden');
            },
        }),
        [CustomToastAnimation]
    );
    return (
        <>
            <ReactTooltip
                id={TOAST_DISMISS_TOOLTIP_ID}
                className="toast-dismiss-tooltip"
                place="top"
                effect="solid"
                delayShow={400}
            />
            <ToastContainer ref={containerRef} {...toastConfiguration} {...props} />
        </>
    );
}
